import useDictStore from "@/store/modules/dict";
import { getDicts } from "@/api/system/dict/data";
import mitt from "mitt";

//  观察者,通知那些订阅者可以来更新字典的数据了
const gettingDictQueueMap = mitt();

//  如果包含dictType 的情况下,表示已经正在获取数据
const gettingSet = new Set();

/**
 * 获取字典数据
 */
export function useDict(...args) {
  //  每一个人的 res 都不同
  const res = ref({});
  return (() => {
    args.forEach((dictType) => {
      res.value[dictType] = [];
      const dicts = useDictStore().getDict(dictType);
      if (dicts) {
        res.value[dictType] = dicts;
      } else {
        //  把这个res放入 queue 中 ,等待完成之后全部更新
        if (gettingSet.has(dictType)) {
          // useDictStore().setDict(dictType, null);
          // console.log(`notify ${dictType} >>>>>>>>>>>`);
          res.value[dictType] = [];
          gettingDictQueueMap.on(dictType, (dictData) => {
            res.value[dictType] = dictData;
          });
          return;
        }

        // console.log(`fetching ${dictType} >>>>>>>>>`);
        gettingSet.add(dictType);

        getDicts(dictType).then((resp) => {
          const data = (res.value[dictType] = resp.data.map((p) => ({
            label: p.dictLabel,
            value: p.dictValue,
            elTagType: p.listClass,
            elTagClass: p.cssClass,
            remark: p.remark
          })));
          useDictStore().setDict(dictType, res.value[dictType]);
          //  notify All
          gettingDictQueueMap.emit(dictType, data);
        });
      }
    });

    return Object.keys(res.value).reduce((acc, dictType) => {
      return Object.assign(acc, {
        [dictType]: computed(() => {
          return unref(res)[dictType];
        })
      });
    }, {});
    // return toRefs(res.value);
  })();
}
